import { Directive, ElementRef, Inject, OnDestroy, OnInit, Self } from '@angular/core';
import { debounceTime, fromEvent, Subject, takeUntil } from 'rxjs';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';

@Directive({
  selector: '[cdk-virtual-scroll-viewport-resize-aware]',
  standalone: true
})
export class CdkVirtualScrollViewportHeightAwareDirective implements OnInit, OnDestroy {
  protected readonly destroy$: Subject<void> = new Subject();
  private visibilityObserver!: IntersectionObserver;

  constructor(
    @Self() @Inject(CdkVirtualScrollViewport) private readonly viewportComponent: CdkVirtualScrollViewport,
    private elementRef: ElementRef
  ) {}

  ngOnInit() {
    // Handle window resize events
    fromEvent(window, 'resize')
      .pipe(
        debounceTime(50),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        console.debug('Checking viewport size after window resize');
        this.viewportComponent.checkViewportSize();
      });

    this.visibilityObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          console.debug('Element became visible');
          this.viewportComponent.checkViewportSize();
        }
      });
    });

    this.visibilityObserver.observe(this.elementRef.nativeElement);
  }

  ngOnDestroy() {
    this.visibilityObserver.disconnect();
    this.destroy$.next();
    this.destroy$.complete();
  }
}
